import { signal } from "./reactive.js";

const routes = [];
export const currentRoute = signal(null); // { path, params, route }

function compile(path) {
  const names = [];
  const regex = new RegExp(
    "^" +
      path.replace(/:[^/]+/g, (m) => {
        names.push(m.slice(1));
        return "([^/]+)";
      }) +
      "/?$"
  );
  return { regex, names };
}

export function addRoute(path, screen, { auth = true, chrome = true } = {}) {
  routes.push({ path, screen, auth, chrome, ...compile(path) });
}

function resolve(pathname) {
  for (const route of routes) {
    const match = pathname.match(route.regex);
    if (match) {
      const params = {};
      route.names.forEach((n, i) => (params[n] = decodeURIComponent(match[i + 1])));
      return { route, params };
    }
  }
  return null;
}

let isLoggedIn = () => false;
export function setAuthCheck(fn) {
  isLoggedIn = fn;
}

export function navigate(path, { replace = false } = {}) {
  if (replace) history.replaceState({}, "", path);
  else history.pushState({}, "", path);
  handleLocation();
}

export function handleLocation() {
  const pathname = location.pathname;
  const resolved = resolve(pathname);

  if (!resolved) {
    navigate(isLoggedIn() ? "/" : "/login", { replace: true });
    return;
  }
  if (resolved.route.auth && !isLoggedIn()) {
    navigate("/login", { replace: true });
    return;
  }
  if (!resolved.route.auth && isLoggedIn() && pathname === "/login") {
    navigate("/", { replace: true });
    return;
  }
  currentRoute({ path: pathname, params: resolved.params, route: resolved.route });
}

export function initRouter() {
  window.addEventListener("popstate", handleLocation);
  document.addEventListener("click", (e) => {
    const link = e.target.closest("[data-link]");
    if (link) {
      e.preventDefault();
      navigate(link.getAttribute("href") || link.dataset.link);
    }
  });
  handleLocation();
}
